import { Cloud, CloudOff, Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function AutosaveIndicator({ status, lastSaved }) {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    if (status === 'saved' && lastSaved) {
      const updateTimeAgo = () => {
        const seconds = Math.floor((Date.now() - lastSaved) / 1000);
        if (seconds < 5) setTimeAgo('just now');
        else if (seconds < 60) setTimeAgo(`${seconds}s ago`);
        else setTimeAgo(`${Math.floor(seconds / 60)}m ago`);
      };
      
      updateTimeAgo();
      const interval = setInterval(updateTimeAgo, 1000);
      return () => clearInterval(interval);
    }
  }, [status, lastSaved]);

  if (status === 'saving') {
    return (
      <div className="flex items-center gap-2 text-sm text-blue-600">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span>Saving...</span>
      </div>
    );
  }

  if (status === 'saved') {
    return (
      <div className="flex items-center gap-2 text-sm text-green-600">
        <Cloud className="w-4 h-4" />
        <span>Saved {timeAgo}</span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex items-center gap-2 text-sm text-red-600">
        <CloudOff className="w-4 h-4" />
        <span>Save failed • Retry</span>
      </div>
    );
  }

  return null;
}